export class Search {
	/**
	 * Init the class
	 *
	 * @param {HTMLElement} searchEl The root element of the block
	 */
	constructor(searchEl) {
		// Define classes, selectors, and magic
		this.controlClass = 'mobile-search-open';
		const closeSearch = document.getElementById('close-search-mobile');

		// Toggle menu
		searchEl.addEventListener('click', this.searchToggleClicked.bind(this));
		closeSearch.addEventListener(
			'click',
			this.searchToggleClicked.bind(this)
		);
	}

	/*
	 * Toggles search popup on mobile when icon is clicked
	 *
	 * @return    {void}
	 */
	searchToggleClicked() {
		const alreadyOpen = document.body.classList.contains(this.controlClass);
		// Add the body class
		if (!alreadyOpen) {
			document.body.classList.add(this.controlClass);
		} else {
			document.body.classList.remove(this.controlClass);
		}
	}
}
